import React, { useState } from "react";
import { Link } from "react-router-dom";

const ValeurSection = () => {
  const [currentPerson, setCurrentPerson] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const people = [
    {
      id: 1,
      name: "Philippe Foisy",
      title: "Président et fondateur",
      title2: "F.S.A, F.I.C.A",
      image: "assets/image/3_Philippe-Foisy.png",
      bio: "Actuaire ayant pratiqué pendant 10 ans dans le domaine de l’assurance de personnes et des produits d’investissements avant de se lancer comme entrepreneur dans le monde de l’investissement immobilier, notre fondateur est également Fellow de l’Institut Canadien des Actuaires et un expert en évaluation, tarification et design de produits financiers complexes de tous horizons. Après 10 ans de carrière en actuariat traditionnel, Philippe s’est lancé à temps plein dans sa nouvelle passion qui grandissait déjà depuis quelques années : l’investissement immobilier multi-résidentiel. C’est en alliant son amour pour les mathématiques et la finance à celui pour l’immobilier qu’est né à ce moment ce qui allait devenir la branche Conseils de l’écosystème Beatimo. Philippe est également enseignant et un contributeur important au Collège MREX depuis les tous débuts en 2017, où il partage ses connaissances en modélisation d’actifs financiers immobiliers ainsi que son expérience concrète sur le terrain en tant qu’entrepreneur propriétaire de plus de 300 logements et d’une forte proportion des terrains au centre-ville de St-Hyacinthe.",
      bio2: " Philippe est avant tout un passionné. Quand son cœur et ses pensées se posent sur un objectif, un rêve : rien ne peut l’arrêter. Il est persévérant au travers des tempêtes, fidèle et loyal envers ceux qui l’entourent. Il est un visionnaire guidé par son cœur et ses valeurs profondes. Très intellectuel de nature tout en ayant un côté artistique très fort plutôt atypique dans le profil des actuaires traditionnels, notre président et fondateur adore chercher et développer des solutions créatives aux problèmes les plus complexes.",
      // bio: "Philippe Foisy incarne l'excellence dans le monde de l'immobilier, cumulant les titres de Président & Fondateur de Beatimo. Fort d'une expérience de plus de 15 ans, il a acquis une expertise pointue dans tous les aspects de l'investissement immobilier et de la création de valeur. Sa carrière remarquable lui a permis de tisser un réseau solide de relations avec des partenaires stratégiques et des investisseurs de renom.",
      // bio2: "Diplômé expert immobilier, avec une spécialisation en gestion d'actifs, Philippe Foisy a fait ses preuves au sein de grandes sociétés de gestion de fonds, affinant son savoir-faire et consolidant sa réputation. En tant qu'entrepreneur chevronné, il apporte à Beatimo une direction stratégique, guidée par l'innovation et une connaissance approfondie du marché immobilier, afin de créer des opportunités d'investissement exceptionnelles et de maximiser les rendements pour ses clients et partenaires."
    },
    {
      id: 2,
      name: "Mathieu Dubois",
      title: "Vice Président - Développement des Affaires ",
      title2: "C.F.A, B.Sc Finance ",
      image: "assets/image/4_Mathieu-Dubois.png",
      bio: "Mathieu Dubois est un professionnel passionné de finance et d'immobilier, fier détenteur du prestigieux titre de Chartered Financial Analyst (CFA). Au cours des dix dernières années, il a travaillé comme analyste et gestionnaire de portefeuille pour les ultrafortunés, gérant plus de 400 millions de dollars d’actifs. Sa passion pour l'immobilier remonte à sa jeunesse avec sa famille. En 2018, Mathieu a repris le parc immobilier familial avec sa sœur. En 2020, il a entrepris le Certificat Maître en Ingénierie Financière du Collège MREX, où il a rencontré Philippe Foisy, donnant naissance à une connexion mentale et professionnelle qui s'est transformée en partenariat dès 2021. Mathieu est reconnu pour son intégrité, sa curiosité, son ouverture d'esprit et son engagement à bâtir des relations solides. Sa vision à long terme et sa nature réfléchie lui permettent de naviguer efficacement dans des contextes financiers complexes, combinant ses connaissances financières avec sa passion pour l'immobilier pour créer des opportunités uniques et innovantes chez Beatimo - Services Conseils.",
    },
    {
      id: 3,
      name: "Karim Alidou D’anjou",
      title: "Consultant Senior  ",
      title2: "B.Sc Actuariat ",
      image: "assets/image/1_Karim-Alidou-dAnjou.png",
      bio: "Karim Alidou d’Anjou a découvert  le domaine de l’actuariat en discutant avec un ami, alliant son penchant pour les sciences et les mathématiques. Diplômé en mathématiques actuarielles de l'Université Concordia en 2015, il a débuté sa carrière dans une firme d’Actuaires-Conseils bien établie à Montréal. En parallèle, Karim est un entraîneur de soccer passionné, ayant participé aux Jeux du Québec et transmis cette passion à de jeunes athlètes. Son désir d'aider les autres à atteindre leurs objectifs se manifeste tant dans son rôle chez Beatimo, où il gère les opérations et conseille les clients, que dans sa carrière antérieure chez Normandin-Beaudry. En 2022, Karim a rejoint Philippe Foisy pour développer la pratique de consultation en immobilier de Beatimo, apportant son expertise en modélisation financière et en automatisation. Son engagement à donner le meilleur de lui-même chaque jour contribue à la croissance et au succès de Beatimo.",
    },
    {
      id: 4,
      name: "Samuel Hansen",
      title: "Consultant Senior  ",
      title2: "C.F.A, M.Sc Finance ",
      image: "assets/image/5_Samuel-Hansen.png",
      bio: "Samuel Hansen est titulaire d'une maîtrise en finances et détient également le titre de C.F.A. Suite à ses études, il a premièrement travaillé dans les domaines des produits à revenus fixes, du capital de risque et des prêts bancaires pour les entreprises publiques, accumulant une solide expérience dans les produits financiers complexes. En tant que directeur des investissements au sein d'un fonds immobilier avec des actifs évalués à plus de 50 millions de dollars, Samuel a également acquis une expertise de pointe dans le secteur de la construction neuve et du développement de terrain. Chez Beatimo Services-Conseils, il est une référence en la matière pour nos clients développeurs de projets multi-résidentiels neufs, apportant son expertise en modélisation financière, en structure de financement et de partenariats, sans oublier les conseils spécifiques à valeur ajoutée qu’il prodigue selon les particularités du projet analysé. En dehors du travail, Samuel maintient sa forme physique en s'entraînant régulièrement et en pratiquant le golf. Son engagement à offrir des solutions innovantes et responsables fait de lui un atout précieux pour Beatimo.",
    },
    {
      id: 5, 
      name: "Jean-Philippe Lucmort",
      title: "Analyste Financier  ",
      title2: "B.Sc Finance ",
      image: "assets/image/2_Jean-Philippe-Lucmort.png",
      bio: "Après avoir obtenu son baccalauréat en administration des affaires avec une concentration en finance à l'UQAM en 2018, Jean-Philippe Lucmort a commencé sa carrière chez Groupe Lacasse en tant qu'analyste en prix de revient. Cette expérience lui a permis d'acquérir une solide base en analyse financière. Sa passion pour l'immobilier s'est développée grâce à son meilleur ami Gabriel Foisy, dont l'enthousiasme contagieux l'a profondément inspiré. Cette curiosité grandissante pour le monde de l’immobilier ainsi que son désir très fort de faire une différence dans l’écosystème Beatimo en constante évolution l’ont amené à faire le saut dans notre équipe en tant qu'analyste financier, perfectionnant ses compétences en collaboration avec des professionnels établis et inspirants. Fier papa de deux garçons, Jean-Philippe est reconnu pour son engagement familial, son intérêt pour le Bitcoin, et son dévouement à aider les autres dans leurs décisions financières. Son intégrité, son attitude irréprochable en toutes circonstances et sa curiosité font de lui un membre précieux et grandement apprécié des clients ainsi que toute notre équipe.",
    },
    {
      id: 6,
      name: "Julie Roy",
      title: "Adjointe Exécutive  ",
      image: "assets/image/11_Julie-Roy.png",
      bio: "Julie Roy a débuté son parcours professionnel avec une formation en technique d'éducation à l'enfance, développant des compétences en organisation, communication et gestion. Rejoignant Beatimo en 2019 en tant que chargée de gestion locative, elle a rempli plusieurs rôles afférents au bon fonctionnement de projets immobiliers divers. Depuis un an, Julie sert en tant qu'adjointe exécutive pour Beatimo Services-Conseils, mettant à profit ses compétences organisationnelles pour soutenir l'équipe et les clients. Passionnée par la danse et la nature, Julie trouve équilibre et créativité dans ces activités. Son engagement à anticiper les besoins de l’équipe et à créer des solutions proactives fait d'elle une collaboratrice dévouée, prête à contribuer au succès de Beatimo et à l’accomplissement des objectifs de l’équipe.",
    },
    // Your people objects...
  ];

  const openNavValeur = () => {
    setIsSidebarOpen(true);
  };

  const closeNavValeur = () => {
    setIsSidebarOpen(false);
    setCurrentPerson(null);
  };

  const handlePersonClick = (person) => {
    setCurrentPerson(person);
    openNavValeur();
  };

  return (
    <>
      <section className="valeur-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="valeur-content">
                <h5>
                  <img
                    src="assets/image/nos-services-icon.png"
                    alt="Valeur-Section-Img"
                  />{" "}
                  Passionnée
                </h5>
                <h1>
                  Créateurs <br />
                  de valeur <br />
                  <span> immobilière </span>
                </h1>
              </div>
            </div>
            <div className="col-lg-6">
              {people.map((person) => (
                <div key={person.id} className="valeur-image">
                  <Link onClick={() => handlePersonClick(person)}>
                    <img
                      src={person.image}
                      className="img-fluid"
                      alt="Valeur-Section-Img"
                    />
                    <div className="valeur-image-content">
                      <div>
                        <h4>{person.name} <span>{person.title2}</span></h4>
                        <p>{person.title}</p>
                      </div>
                      <img
                        src="assets/image/arrow_right.png"
                        alt="Valeur-Section-Img"
                      />
                    </div>
                  </Link>
                </div>
              ))}
            </div>
            <div className="col-lg-12">
              <div className="Nous-content">
                <h5>
                  <img
                    src="assets/image/nos-services-icon.png"
                    alt="Valeur-Section-Img"
                  />{" "}
                  carrière
                </h5>
                <h1>
                  Nous <span> sommes </span> toujours à <br /> la recherche de{" "}
                  <span> talents.</span> <br /> Êtes-vous{" "}
                  <span> partant ? </span>
                </h1>
                <div className="Nous-button">
                  <Link to="/carrier">
                    <button className="Nous-btn">découvrir nos postes </button>
                    <img
                      className="ps-2"
                      src="assets/image/arrow_right.png"
                      alt="Valeur-Section-Img"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {isSidebarOpen && <div className="overlay" onClick={closeNavValeur}></div>}
      <div id="SidenavValeur" className={`sidenav ${isSidebarOpen ? "open" : ""}`}>
        <Link
          to={{ javascript: void 0 }}
          className="closebtn"
          onClick={() => closeNavValeur()}
        >
          <svg
            width={47}
            height={47}
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              fill="white"
            />
            <rect
              x={46}
              y={46}
              width="45.5"
              height="45.5"
              rx="22.75"
              transform="rotate(-180 46 46)"
              stroke="white"
            />
            <path
              d="M19.2807 28.2057L18.2891 27.2141L22.2557 23.2474L18.2891 19.2807L19.2807 18.2891L23.2474 22.2557L27.2141 18.2891L28.2057 19.2807L24.2391 23.2474L28.2057 27.2141L27.2141 28.2057L23.2474 24.2391L19.2807 28.2057Z"
              fill="#007367"
            />
          </svg>
        </Link>
        {currentPerson && (
          <div className="foisy-sidebar">
            <div className="foisy-sidebar-img">
              <img
                src={currentPerson.image}
                className="img-fluid"
                alt="Valeur-Section-Img"
              />
            </div>
            <div className="foisy-sidebar-content">
              <div className="foisy-sidebar-heading">
                <p>{currentPerson.title}</p>
                <h1>{currentPerson.name}</h1>
                <h5>{currentPerson.title2}</h5>
              </div>
              <div className="foisy-sidebar-content-inner">
                <h5>
                  <svg
                    width={16}
                    height={14}
                    viewBox="0 0 16 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.91451 13.1325H0.55399C0.2539 13.1325 0 12.8902 0 12.5785V1.42901C0 1.12892 0.242358 0.875 0.55399 0.875H9.91451C10.0646 0.875 10.2031 0.932711 10.3069 1.03659L15.8355 6.56517C16.0548 6.78447 16.0548 7.13073 15.8355 7.33848L10.3069 12.9594C10.2031 13.0633 10.0646 13.121 9.91451 13.121V13.1325Z"
                      fill="#007367"
                    />
                  </svg>
                  BIOGRAPHIE
                </h5>
                <p dangerouslySetInnerHTML={{ __html: currentPerson.bio }}></p>
                <p dangerouslySetInnerHTML={{ __html: currentPerson.bio2 }}></p>
                {/* <p>{currentPerson.bio2}</p> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ValeurSection;
